import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Caller, HttpService } from './http.service';
import { AppConstants } from './model/constants.model';
import { dcElement } from './model/dcElement.model';
import { dcSearchTags } from './model/dcSearchTags.model';
import { dcTag } from './model/dcTag.model';
import { dcTreeNode } from './model/dcTreeNode.model';
import { BaseRequest } from './model/request/request.model';
import { IdcActionInfo, dcActionInfo } from './model/response/dcActionInfo.model';
import { dcSuggestedValue } from './model/suggested-value.model';
import { User } from './model/user.model';

@Injectable()
export class TagService {
  constructor(private httpService: HttpService) {}

  public searchTags(searchKey: string): Observable<dcTag[]> {
    const myParams: any = {
      params: new HttpParams().set('searchKey', searchKey)
    };

    const ob = this.httpService.get(`tags?searchKey=${searchKey}`, myParams).pipe(
      tap(x => {
        console.log(x);
      }),
      map((res: any) => {
        if (res) {
          return res;
        }
      })
    );
    return ob;
  }

  public showSearchResponse(requestCollection: BaseRequest[]): Observable<dcTag[]> {
    return this.httpService.put('tags/tagsDeepSearch', requestCollection);
  }

  public GetHierarchy(tag: dcTag, sortByNamingPattern: boolean = false, levelDepth: number = -1): Observable<dcTreeNode[]> {
    return this.httpService.post<dcTreeNode[]>(
      `tags/GetHierarchy?sortByNamingPattern=${sortByNamingPattern}&levelDepth=${levelDepth}`,
      tag
    );
  }

  public GetElementHierarchy(tag: dcTag): Observable<dcElement[]> {
    return this.httpService.post<dcElement[]>('tags/GetElementHierarchy', tag);
  }

  public GetElementTemplateHierarchy(tag1: dcTag): Observable<dcTreeNode[]> {
    if (tag1) {
      const tempTag = new dcTag();
      tempTag.ObjectID = tag1.ObjectID;
      tempTag.SourceObjectID = tag1.SourceObjectID;
      tempTag.ElementTypeID = tag1.ElementTypeID;
      tempTag.TagName = tag1.TagName;
      tempTag.IsLazyLoading = false;
      tempTag.IsShallowsearch = false;

      return this.httpService.post<dcTreeNode[]>('tags/GetElementTemplateHierarchy', tempTag);
    }
  }

  public findTagsGroupBy(tag: dcTag, caller?: Caller): Observable<dcTag[]> {
    return this.httpService.post<dcTag[]>('tag/FindTagsGroupBy', tag, caller);
  }

  public FindTags(tag: dcTag, caller?: Caller): Observable<dcTag[]> {
    return this.httpService.post<dcTag[]>('tag/FindTags', tag, caller);
  }

  public GetTags(tag: dcTag[]): Observable<dcTag[]> {
    return this.httpService.post<dcTag[]>('tag/GetTags', tag);
  }

  public AdvancedSearch(searhParams: dcSearchTags, caller?: Caller): Observable<dcTag[]> {
    return this.httpService.post<dcTag[]>('tag/AdvancedSearch', searhParams, caller);
  }

  public SaveUserFavoriteApps(apps: dcTag[]) {
    return this.httpService.post<IdcActionInfo>('app/saveUserProfileApps', apps);
  }

  public AdvancedTagSearch(searchParams: dcSearchTags, caller?: Caller): Observable<dcTag[]> {
    return this.httpService.post<dcTag[]>('tag/AdvancedTagSearch', searchParams, caller);
  }

  public searchTagWithOR(orTags: dcTag[], andTags: dcTag[]) {
    return this.httpService.post<dcTag[]>(
      `tags/GetTagsWithOR`,
      { orTags, andTags },
      'searchTagWithOR'
    );
  }

  //Currently no other options for get the tags of editable apps, should be removed once able to get it using search tag.
  public GetEditableAppTags(): Observable<dcTag[]> {
    return this.httpService.get<dcActionInfo<dcTag>>(`AppDesigner/GetEditableAppTags`).pipe(
      map(res => {
        if (res && res.Value) return res.Value;
      })
    );
  }

  public GetUserElement(LoginID: any): Observable<User> {
    return this.httpService.get(`tags/GetUserElement?LoginID=${LoginID}`);
  }

  public DeleteContentTags(contentTagList: dcTag[]): Observable<IdcActionInfo> {
    return this.httpService.post<IdcActionInfo>('tags/DeleteContentTag', contentTagList);
  }

  public saveContentTags(contentTagList: dcTag[]): Observable<IdcActionInfo> {
    return this.httpService.post<IdcActionInfo>('tags/SaveContentTags', contentTagList);
  }

  public findTagByName(tag: dcTag, cancelToken?: Caller): Observable<dcTag[]> {
    const advancedSearch = new dcSearchTags();
    advancedSearch.Filter = [];
    advancedSearch.Filter = [tag];
    advancedSearch.Target = [];
    advancedSearch.IsElement = false;
    advancedSearch.IsGroup = true;
    return this.httpService.post<dcTag[]>('tag/AdvancedSearch', advancedSearch, cancelToken);
  }

  getCategory() {
    const categoryFilter: dcTag[] = [AppConstants.constantTags.CATEGORY_FILETR_TAG];
    const categorySearchTag = AppConstants.constantTags.CATEGORY_SEARCH_TAG;
    categorySearchTag.Filter = categoryFilter;
    return this.AdvancedSearch(categorySearchTag);
  }

  public searchPiTagByName(piTagName: string, pageCount?: number) {
    const url = pageCount ? `PI/PiPointSearchEXT?PageCount=${pageCount}` : 'PI/PiPointSearchEXT';
    return this.httpService.post(url, {
      TagName: piTagName
    });
  }

  public GetTagByElementType(elementType: dcSuggestedValue, isBaseTemplate?: boolean) {
    const url =
      'tags/GetTagByElementType' + (isBaseTemplate ? `?isBaseTemplate=${isBaseTemplate}` : '');
    return this.httpService.post<dcTag[]>(url, elementType);
  }
}
